import React from 'react';
import PropTypes from 'prop-types';
import { getColor } from 'core/utils/Styles';

const StarEmpty = ({ stroke, ...props }) =>
	<svg viewBox="0 0 123.38 117.69" width="1em" height="1em" {...props}>
		<path
			d="M64.64 2.22l15.71 36.79 39.85 3.58c1.76.15 3.06 1.7 2.91 3.46-.07.86-.48 1.6-1.08 2.13L91.89 74.5l8.92 39.02c.39 1.72-.68 3.44-2.41 3.84-.88.2-1.76.02-2.47-.44L61.69 96.44l-34.35 20.54c-1.52.91-3.48.41-4.39-1.1-.44-.74-.55-1.58-.37-2.35h0l8.92-39.02L1.34 48.17a3.197 3.197 0 01-.3-4.51c.59-.68 1.4-1.04 2.24-1.09L43.03 39 58.75 2.2a3.199 3.199 0 014.2-1.69c.79.34 1.38.97 1.69 1.71h0zm-2.95 9.38l13.53 31.67h.01a3.191 3.191 0 002.67 1.93l34.31 3.08-25.84 22.55c-.95.74-1.44 1.99-1.15 3.24l7.68 33.58L63.39 90c-.51-.32-1.1-.49-1.7-.49V11.6h0z"
			fillRule="evenodd"
			clipRule="evenodd"
			stroke={stroke}
			strokeWidth={0.5}
			strokeMiterlimit={2.613}
		/>
	</svg>;

StarEmpty.propTypes = {
	stroke: PropTypes.string,
};

StarEmpty.defaultProps = {
	stroke: getColor('gray'),
};

export default StarEmpty;
